import { render, staticRenderFns } from "./CustomUserTagsSection.vue?vue&type=template&id=3e7f587a&"
import script from "./CustomUserTagsSection.vue?vue&type=script&lang=js&"
export * from "./CustomUserTagsSection.vue?vue&type=script&lang=js&"
import style0 from "./CustomUserTagsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports